
import { Component, Vue } from 'vue-property-decorator';
import { availableComponents } from '@/router/available-components';

@Component({
  name: 'CustomView'
})
export default class CustomView extends Vue {
  async mounted() {
    // Cargar el componente dinámicamente basado en el módulo
    const moduleName = this.$route.meta?.module;
    if (moduleName && availableComponents[moduleName]) {
      const componentConfig = availableComponents[moduleName];
      await componentConfig.component();
    }
  }

  get currentComponent() {
    const moduleName = this.$route.meta?.module;
    return moduleName && availableComponents[moduleName]
      ? availableComponents[moduleName].component
      : 'div'; // Fallback a un div vacío si no se encuentra el componente
  }

  get componentProps() {
    return {
      ...this.$route.params,
      ...this.$route.query,
      menuId: this.$route.meta?.menuKey
    };
  }
}
